<template>
  <div class="content">
    <!--左-->
    <article-side-bar :article-list-nav="articleListNav"></article-side-bar>
    <!--右-->
    <div class="content_right">
      <div class="content_header">
        <span class="title">{{curName}}</span>
        <span class="card">{{articleListNav.menuName}} > {{curName}}</span>
      </div>
      <ul class="article_box">
        <li class="article_list" v-for="item in articleList" :key="item.id">
        <router-link :to="{path:'/articleDetail',query:{menuId:item.menuId,plateId:item.plateId,articleId:item.articleId}}">
          <span class="article_title">
            <img src="../assets/images/article/articleRight.png" alt="">{{item.title}}</span>
            <span class="date">{{item.publishTime}}</span>
        </router-link>
        </li>
      </ul>
      <div class="data_null" v-if="articleList==''">
        暂无数据
      </div>
      <div class="page" v-else >
        <vue-pagination
            :current-page="currentPage"
            :total="totalPage"
            :page-size="pageSize"
            @current-change="handleChangeCurrent">
        </vue-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import {queryArticleList, searchArticleList} from '@/api/ArticleList.js'
  import ArticleSideBar from '@/components/ArticleSideBar.vue'
  export default {
    components:{ArticleSideBar},
    props: {
      articleListNav: Object
    },
    data() {
      return {
        search:'',
        articleList: [],
        plateName:'',
        articleId:'',
        //分页参数
        pageSize: 10,
        currentPage: 1,
        totalPage: 100,
      }
    },
    computed: {
      curName(){
        let plate = this.articleListNav.children.find((item)=>{
          console.log(this.$route.query.plateId)
          return item.id == this.$route.query.plateId
        })
        this.handleNav()
        return plate.plateName
      }
    },
    created() {
      this.handleNav()
    },
    methods: {
      handleNav() {
        queryArticleList(this.$route.query.menuId , this.$route.query.plateId, this.currentPage - 1, this.pageSize).then((res) => {
          this.articleList = res.list
          this.pageSize = res.pageParam.pageSize
          this.totalPage = res.pageParam.totalCount
        })
      },
      handleChangeCurrent(val) {
        this.currentPage = val
        this.handleNav()
      },

    }
  }
</script>
<style lang="scss">
  .vue-pagination li a, .vue-pagination li button, .vue-pagination .vue-pagination-skip button, .vue-pagination .vue-pagination-skip input {
    font-size: 16px;
  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  //$themeColor: #3e76fc;
  .content {
    width: 1200px;
    display: flex;
    .content_right {
      width: 1112px;
      padding-left: 34px;
      /*position: absolute;*/
      .content_header {
        width: 100%;
        height: 86px;
        border-bottom: 1px solid $themeColor;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .title {
          font-size: 28px;
          color: $themeColor;
        }
        .card {
          font-size: 14px;
          color: #333;
        }
      }
      .article_box {
        width: 100%;
        min-height: 400px;
        .article_list a{
          height: 54px;
          border-bottom: 1px solid #e1e1e1;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .article_title {
            max-width: 860px;
            overflow:hidden;
            text-overflow:ellipsis;
            white-space:nowrap;
            font-size: 16px;
            color: #333;
           padding-right: 20px;
            img {
              width: 10px;
              height: 12px;
              margin-right: 10px;
            }
          }
          .date {
            font-size: 16px;
            color: #666;
          }
        }
        .article_list:hover {
          .article_title, .date {
            color: $themeColor;
          }
        }
      }
      .data_null{
        position: relative;
        top: -300px;
        left: 0;
        text-align: center;
      }
      .page {
        margin: 70px 0 145px 0;
        display: flex;
        justify-content: center;
        .vue-pagination {
          font-size: 16px;
          color: #999;
          .vue-pagination li a {
            font-size: 16px !important;
          }
        }
      }
    }
  }
</style>
